import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '@blockcatio/tabby-library/lib/components/Spinner';

const PaymentFormLayout = ({
  onSubmit,
  fieldComponents,
  buttonClassName,
  submitText,
  children,
  submitting,
  disabled,
  formClassName,
}) => (
  <form onSubmit={onSubmit} className={`form ${formClassName}${submitting ? ' submitting' : ''}${disabled ? ' disabled' : ''}`}>
    <div className="white-box item-box">
      <div className="inner">
        <div className="row form-row">{fieldComponents}</div>
        <div className="submit-wrapper">
          {children}
          <button disabled={disabled} className={buttonClassName} type="submit">
            {submitText}
          </button>
          <Spinner loading={submitting} />
        </div>
      </div>
    </div>
  </form>
);

PaymentFormLayout.defaultProps = {
  buttonClassName: 'btn',
  submitText: 'Submit',
  submitting: false,
  disabled: false,
  children: '',
  formClassName: '',
};

PaymentFormLayout.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  fieldComponents: PropTypes.arrayOf(PropTypes.node).isRequired,
  buttonClassName: PropTypes.string,
  submitText: PropTypes.string,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  formClassName: PropTypes.string,
};

PaymentFormLayout.displayName = 'PaymentFormLayout';

export default PaymentFormLayout;



// WEBPACK FOOTER //
// ./src/components/PaymentFormLayout.js